import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import UAParser from 'ua-parser-js';

import './style.scss';

import DocumentIcon from './icons/document.inline.svg';
import LinkIcon from './icons/link.inline.svg';
import PlusIcon from './icons/plus.inline.svg';
import CrossIcon from './icons/cross.inline.svg';
import ReplayIcon from './icons/replay.inline.svg';

import CirclePlusIcon from './icons/circle-plus.inline.svg';
import CircleCrossIcon from './icons/circle-cross.inline.svg';
import CircleDownloadIcon from './icons/circle-download.inline.svg';
import CircleLinkIcon from './icons/circle-link.inline.svg';

function checkUA(ua) {
  let parser = new UAParser();
  let result = parser.getResult();

  if (result.os.name === ua) {
    return '';
  } else {
    return '=';
  }
}

const Button = props => {
  const renderIcon = () => {
    if (props.isAction) {
      switch (props.icon) {
        case 'plus':
          return <CirclePlusIcon />;
        case 'cross':
          return <CircleCrossIcon />;
        case 'download':
          return <CircleDownloadIcon />;
        case 'link':
          return <CircleLinkIcon />;
        default:
          return null;
      }
    }

    switch (props.icon) {
      case 'document':
        return <DocumentIcon />;
      case 'link':
        return <LinkIcon />;
      case 'plus':
        return <PlusIcon />;
      case 'cross':
        return <CrossIcon />;
      case 'replay':
        return <ReplayIcon />;
      default:
        return null;
    }
  };

  if (props.openInNewTab || props.annualReportPage) {
    return (
      <a
        href={
          props.annualReportPage
            ? `/pdfs/Professional_Standards_Councils_Annual_Report_2021-22.pdf#page${checkUA('iOS')}${
                props.annualReportPage
              }`
            : props.to
        }
        className={`button is-${props.color} ${props.isAction && 'is-action'}`}
        target="_blank"
        rel="noopener noreferrer"
        disabled={props.disabled}
        onClick={props.onClick}
      >
        {renderIcon()}
        {props.label}
        <span className="sr-only">&nbsp;{props.srLabelContinuation}</span>
      </a>
    );
  }

  if (props.to) {
    return (
      <Link
        to={props.to}
        className={`button is-${props.color} ${props.isAction && 'is-action'}`}
        disabled={props.disabled}
        onClick={props.onClick}
      >
        {renderIcon()}
        {props.label}
        <span className="sr-only">&nbsp;{props.srLabelContinuation}</span>
      </Link>
    );
  }

  return (
    <button
      className={`button is-${props.color} ${props.isAction && 'is-action'}`}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {renderIcon()}
      {props.label}
      <span className="sr-only">&nbsp;{props.srLabelContinuation}</span>
    </button>
  );
};

Button.propTypes = {
  to: PropTypes.string,
  color: PropTypes.string,
  label: PropTypes.string.isRequired,
  srLabelContinuation: PropTypes.string,
  icon: PropTypes.oneOf(['document', 'link', 'plus', 'cross', 'replay', 'download']),
  openInNewTab: PropTypes.bool,
  disabled: PropTypes.bool,
  isAction: PropTypes.bool,
  annualReportPage: PropTypes.number,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  to: '',
  icon: null,
  onClick: () => {},
};

export default Button;
